<template>
  <BreadCrumb PageTitle="Modifier Utilisateur" />
  <UserEdit :userId="userId"  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import UserEdit from "../../components/Users/UsersList/UserEdit.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "UserEditPage",
  components: {
    BreadCrumb,
    UserEdit,
  },

  setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
}
});
</script>